'use client';

import { usePathname } from 'next/navigation';
import { useEffect, useMemo, useState } from 'react';
import { Layout } from './layout/Layout';
import { City } from '../models';
import { FooterProps } from '../models/footer';
import { NotFoundComponent } from './pages/NotFound';
import { Category } from '../models/categories';
import { getPageBlocks } from '../lib/services/clientProxy';

type INotFoundPageProps = {
  cities: City[];
};

export function NotFoundPage({ cities }: INotFoundPageProps) {
  const pathname = usePathname();

  const city = useMemo(() => {
    const match = /^\/(\w+)\//.exec(pathname);

    if (!match) {
      return cities[0];
    }

    const citySlug = match[1];

    return cities.find(({ url }) => url === citySlug) ?? cities[0];
  }, [cities, pathname]);

  const [pageBlocks, setPageBlocks] = useState<{
    categoriesForHeader: Category[];
    footerProps: FooterProps;
  } | null>(null);

  useEffect(() => {
    getPageBlocks(city.id).then((response) => {
      setPageBlocks(response);
    });
  }, [city.id]);

  return (
    <Layout
      footerProps={
        pageBlocks?.footerProps ?? {
          contactList: { results: [] },
          pageList: { results: [] },
          socials: { results: [] },
          socialsLinks: { results: [] },
        }
      }
      currentCity={city}
      categoriesForHeader={pageBlocks?.categoriesForHeader ?? []}
      page={{ title: 'Страница не найдена', type: 'error' }}
    >
      <NotFoundComponent currentCity={city} />
    </Layout>
  );
}
